import { Injectable } from '@angular/core';

import { TraceViewModel } from '../view-models/trace-viewmodel';
import { CaliperViewModel } from '../view-models/caliper-viewmodel';

@Injectable({
    providedIn: 'root',
})
export class CaliperFactoryService {
    create(trace: TraceViewModel, coordinates: { x: number; y: number }): CaliperViewModel | null {
        const { channel, layout } = trace;
        if (!trace || !layout || !channel) return null;
        let caliper = new CaliperViewModel(trace, layout, channel);

        caliper.opacity = 1;
        caliper.setPositionX(coordinates.x, 15);
        caliper.window.opacity = 0;

        return caliper;
    }
}
